import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./login/logout.component";
import { HomeComponent } from "./home/home.component";
import { ProductsComponent } from "./products/products.component";
import { ProductDetailComponent } from "./products/product-detail/product-detail.component";
import { ProductSummaryComponent } from "./products/product-summary/product-summary.component";
import { ExportProductsComponent } from "./products/export_products.component";
import { SalesPresentersComponent } from "./products/sales-presenters/sales-presenters.component";
import { AllProductsComponent } from "./products/all-products/all-products.component";
import { ErrorComponent } from "./error/error.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        redirectTo: "/products",
        pathMatch: "full"
      },
      {
        path: "export-list/:shortId",
        component: LoginComponent
      },
      {
        path: "all-products/:season/:id",
        component: AllProductsComponent
      },
      {
        path: "products",
        component: ProductsComponent
      },
      {
        path: "login",
        component: LoginComponent
      },
      {
        path: "login/:shortId",
        component: LoginComponent
      },
      {
        path: "login/:shortId/:email",
        component: LoginComponent
      },
      {
        path: "logout",
        component: LogoutComponent
      },
      {
        path: "home",
        component: HomeComponent
      },
      {
        path: "product-summary",
        component: ProductSummaryComponent
      },
      {
        path: "product-detail",
        component: ProductDetailComponent
      },
      {
        path: "sales-tools/:shortId",
        component: SalesPresentersComponent
      },
      {
        path: "error/:type",
        component: ErrorComponent
      },
      {
        path: "**",
        redirectTo: "/error/not-found"
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts